module.exports = __webpack_public_path__ + "static/media/bg.1bf503eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tocollege/bg.png
// module id = 851
// module chunks = 0